/* unplugin-vue-components disabled */import { render } from "./DowntimeDetailItem.vue?vue&type=template&id=6e2481d2&scoped=true&ts=true"
import script from "./DowntimeDetailItem.vue?vue&type=script&lang=ts"
export * from "./DowntimeDetailItem.vue?vue&type=script&lang=ts"

import "./DowntimeDetailItem.vue?vue&type=style&index=0&id=6e2481d2&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2481d2"]])

export default __exports__